import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// 解决路由不能重复点击的问题
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

let importMyViews = (file) => () =>
  import( /* webpackChunkName: "views" */ `../views/${file}.vue`);

const routes = [{
  path: '/',
  redirect: '/product'
}, {
  path: '/product',
  name: 'product',
  component: importMyViews('productFeatures/ProductHome'),
}, {
  path: '/setting',
  name: 'setting',
  component: importMyViews('setting/SettingManager'),
  children: [{
    path: '/setting/baseMapSetting',
    name: 'baseMapSetting',
    component: importMyViews('setting/BaseMapSetting'),
  }]
}, {
  path: '/help/updateLogs',
  name: 'updateLogs',
  component: importMyViews('help/UpdateLogs'),
}];
const router = new VueRouter({
  routes,
});
export default router;